import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import CheckIcon from '@material-ui/icons/Check';

const useStyles = makeStyles(theme => {
  return {
    selected: {
      backgroundColor: `${theme.palette.common.white} !important`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

      '&.Mui-selected:focus': {
        backgroundColor: `${theme.palette.common.muted} !important`,
      },

      '& svg': {
        color: theme.palette.primary.main,
      },
    },
  };
});

const MultipleSelectOption = forwardRef(function MultipleSelectOption(props, ref) {
  const {
    alignItems,
    children,
    className,
    dense,
    disabled,
    disableGutters,
    divider,
    selected,
    tabIndex,
    ...restProps
  } = props;

  const classes = useStyles();

  return (
    <MenuItem
      {...restProps}
      classes={{ ...classes, selected: classes.selected }}
      alignItems={alignItems}
      className={clsx(className)}
      dense={dense}
      disabled={disabled}
      disableGutters={disableGutters}
      divider={divider}
      ref={ref}
      selected={selected}
      tabIndex={tabIndex}
    >
      {children}
      {selected ? <CheckIcon fontSize="small" /> : null}
    </MenuItem>
  );
});

MultipleSelectOption.propTypes = {
  children: Proptypes.node.isRequired,
  alignItems: Proptypes.oneOf(['flex-start', 'center']),
  className: Proptypes.string,
  dense: Proptypes.bool,
  disabled: Proptypes.bool,
  disableGutters: Proptypes.bool,
  divider: Proptypes.bool,
  selected: Proptypes.bool,
  tabIndex: Proptypes.number,
};

MultipleSelectOption.defaultProps = {
  alignItems: 'center',
  className: '',
  dense: true,
  disabled: false,
  disableGutters: false,
  divider: false,
  selected: false,
  tabIndex: -1,
};

MultipleSelectOption.displayName = 'MultipleSelectOption';

export default MultipleSelectOption;
